/* 🤖 this file was generated by svg-to-ts*/
export const icoMedium: {
  name: 'medium';
  data: string;
} = {
  name: 'medium',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.37 7.3a.75.75 0 00-.25-.65L2.25 4.4v-.34h5.8l4.48 9.83 3.94-9.83H22v.34l-1.6 1.53c-.13.1-.2.28-.17.45v11.24c-.03.17.04.35.17.45l1.56 1.53v.34h-7.84v-.34l1.61-1.57c.16-.15.16-.2.16-.44V8.5L11.4 19.9h-.6L5.57 8.5v7.64c-.07.32.06.64.29.86l2.1 2.57v.33H2v-.33L4.1 17a.94.94 0 00.27-.86V7.3z" fill="#909090"/></svg>`
};
